import * as devisConf from '@/configuration/devisConf';
import getLibelleRegroupementPerso
  from '@/services/dcf/regroupementPersonnalise/getLibelleRegroupementPerso';

export default function miseAJourPersonnalise(
  ligneCommande, i18n, referencePersonnalise, lignesCommande,
) {
  ligneCommande.type = devisConf.PERSONNALISE;
  ligneCommande.referencePersonnalise = referencePersonnalise;
  ligneCommande.libelle = getLibelleRegroupementPerso(lignesCommande, referencePersonnalise, i18n);
}
